import { z } from 'zod';

export const STATUS_LABELS: Record<string, string> = {
  setup: 'Em configuração',
  active: 'Ativa',
  suspended: 'Suspensa',
  archived: 'Arquivada',
};

export const STATUS_VARIANTS: Record<string, string> = {
  setup: 'info',
  active: 'success',
  suspended: 'warning',
  archived: 'danger',
};

export const MODULE_LABELS: Record<string, string> = {
  house: 'Casa',
  community: 'Comunidade',
  roles: 'Permissões',
  calendar: 'Calendário',
  obligations: 'Obrigações',
  tasks: 'Tarefas',
  inventory: 'Estoque',
  finance: 'Financeiro',
  documents: 'Documentos',
  reports: 'Relatórios',
};

export const houseFormSchema = z.object({
  name: z.string().min(2, 'Nome é obrigatório'),
  publicName: z.string().min(2, 'Nome público é obrigatório'),
  legalName: z.string().optional().or(z.literal('')),
  documentNumber: z.string().optional().or(z.literal('')),
  email: z.string().email('E-mail inválido').optional().or(z.literal('')),
  phone: z.string().optional().or(z.literal('')),
  city: z.string().optional().or(z.literal('')),
  state: z.string().optional().or(z.literal('')),
  addressLine: z.string().optional().or(z.literal('')),
});

export type HouseForm = z.infer<typeof houseFormSchema>;

export const DEFAULT_MODULES = [
  'house',
  'community',
  'roles',
  'calendar',
  'obligations',
  'tasks',
  'inventory',
  'finance',
  'documents',
  'reports',
] as const;
